module.exports = __webpack_public_path__ + "img/h_3.ac4cba70.png";